export default __webpack_public_path__ + "static/media/ecommerce.b691897c.jpeg";